/* Shopify returns an OR of tags. Refine that complete set by category. */
(function (root) {
    "use strict";

    function normalize(tag) {
        return tag.trim().toLowerCase().replace(/\s*:\s*/, ":");
    }

    function groups(query) {
        var selected = new Map();
        new URLSearchParams(query).getAll("filter.p.tag").forEach(function (value) {
            // Shopify also accepts comma-separated values for one filter.
            value.split(",").forEach(function (tag) {
                tag = normalize(tag);
                var prefix = tag.split(":")[0];
                var category = ["fit", "shape", "frame color", "lens color"].includes(prefix) ? prefix : "tags";
                if (!selected.has(category)) selected.set(category, new Set());
                selected.get(category).add(tag);
            });
        });
        return Array.from(selected.values(), function (values) { return Array.from(values) });
    }

    function matches(tags, selected) {
        var productTags = new Set(tags.map(normalize));
        return selected.every(function (category) {
            return category.some(function (value) { return productTags.has(value) });
        });
    }

    function clear(query) {
        var params = new URLSearchParams(query);
        Array.from(params.keys()).forEach(function (key) {
            if (key.startsWith("filter.") || key === "page") params.delete(key);
        });
        return params.toString();
    }

    function page(query, total, size) {
        var pages = Math.max(1, Math.ceil(total / size));
        var requested = parseInt(new URLSearchParams(query).get("page"), 10) || 1;
        var current = Math.max(1, Math.min(requested, pages));
        return { current: current, pages: pages, start: (current - 1) * size, end: current * size };
    }

    var api = { groups: groups, matches: matches, clear: clear, page: page };
    if (typeof module !== "undefined" && module.exports) module.exports = api;
    else root.CollectionFilterLogic = api;
})(typeof window === "undefined" ? globalThis : window);
